// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"360":"3864c487","408":"88cbf6ad","657":"ca979763","837":"bf841681","928":"518762d9"}[chunkId] + ".css";
};